import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ChartPalette, getChartPalette } from '../../theme/chartPalette';
import { DEFAULT_THEME_MODE, ThemeMode } from '../../theme/guideTokens';

/**
 * Ayudas para que los gráficos (echarts) de protocolos sigan el tema activo de la guía.
 * Los colores salen de `chartPalette`; acá sólo se derivan transparencias y el "marco"
 * del gráfico (título, leyenda, ejes, grilla y tooltip).
 */

/** Paleta del tema activo, estable mientras no cambie el modo (sirve como dependencia de useMemo). */
export const useProtocolChartPalette = (): ChartPalette => {
    const mode = useSelector((state: { Theme?: { mode?: ThemeMode } }) => state.Theme?.mode ?? DEFAULT_THEME_MODE);
    return useMemo(() => getChartPalette(mode), [mode]);
};

/** Color de la paleta con transparencia, para tintes, brillos y degradés. */
export const withAlpha = (hex: string, alpha: number): string => {
    const h = hex.replace('#', '');
    const full = h.length === 3 ? h.split('').map((x) => x + x).join('') : h.slice(0, 6);
    const n = parseInt(full, 16);
    return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${alpha})`;
};

/** Tooltip de echarts con los colores de la guía. */
export const chartTooltipColors = (p: ChartPalette) => ({
    backgroundColor: p.tooltipBackground,
    borderColor: p.axisLine,
    textStyle: { color: p.tooltipText },
});
